import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-black pt-8 px-4 md:pt-12 md:pb-16 overflow-hidden pb-[32px]" data-id="element-22">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-orange-900/20 blur-[100px] rounded-full pointer-events-none" data-id="element-23" />

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-24">
        <h1 className="md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 text-[28px]" data-id="element-25">
          {' '}
          <span className="text-glow text-[32px]" data-id="element-26">
            The Feline Harmony Blueprint
          </span>
        </h1>

        <p className="md:text-2xl mb-8 max-w-2xl mx-auto text-[28px] font-[600] text-[#fff]" data-id="element-27">
          Stop the Hissing, Scratches, and Territorial Wars in Your Home
        </p>

        <div className="relative mb-10 max-w-3xl mx-auto" data-id="element-28">
          <div className="relative rounded-2xl overflow-hidden border border-orange-500/30 box-glow-orange" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/5x64F5Z13ZC1A3NMuKuQRb/ebookcoverpacksm.jpg" alt="The Feline Harmony Blueprint — complete digital protocol shown on laptop, tablet, and phone" className="w-full h-auto block" data-id="element-30" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" data-id="element-31" />
          </div>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-32">
          <Button variant="glow" size="lg" className="w-full md:w-auto min-w-[300px]" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-33">
            YES! I WANT A PEACEFUL HOME
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-34" />
          </Button>
          <p className="text-xs text-gray-500 uppercase tracking-widest" data-id="element-35">
            Instant Digital Access • 100% Secure
          </p>
        </div>
      </div>
    </section>;
}